import { useGetCurrentCoverageQuery } from "types/generated/operations";
import Loader from "uicomponents/Loader";
import ErrorPage from "uicomponents/Error";
import { getProspectUuid } from "utils/idHelpers";
import CurrentCoverage from "./CurrentCoverage";
import { getAppType } from "utils/helper";

const CurrentCoverageModel = (): JSX.Element => {
  const { data, error, loading } = useGetCurrentCoverageQuery({
    variables: { uuid: getProspectUuid(), appType: getAppType() },
    fetchPolicy: "no-cache",
  });

  if (loading) {
    return <Loader />;
  }
  if (error) {
    return <ErrorPage />;
  }
  return <CurrentCoverage data={data?.prospect} />;
};

export default CurrentCoverageModel;
